// extracted by mini-css-extract-plugin
export default {"root":"KXscrKuJ6KDCQMsrK6smwA=="};